<!--
 * @Author: zhangmh31513
 * @Date: 2021-10-29 11:24:50
 * @LastEditTime: 2021-11-08 13:58:29
 * @LastEditors: zhangmh31513
 * @Description: 首页第二页
 * @FilePath: \openplat-web\src\gtn\views\frontViews\developerConference\cloudMeeting.vue
 * 有问题请第一时间来联系我
-->
<template>
  <div class="bg-bg">
    <div class="cloud-main-bg">
      <div class="cloud-show-bg">
        <img
          src="@/assets/developerConference/cloud-show.png"
          alt="云上展厅图标，点击进入云上展厅页"
          class="img-animation"
          title="云上展厅"
          @click="
            jumpDetail('cloudShow');
            dataCollector('云上展厅');
          "
        />
      </div>
      <div class="cloud-fourm-main-bg">
        <img
          src="@/assets/developerConference/cloud-main.png"
          alt="主论坛图标，点击进入主论坛视频页"
          title="主论坛"
          class="img-animation"
          @click="
            jumpDetail('mainForum');
            dataCollector('主论坛');
          "
        />
      </div>
      <div class="cloud-light-bg">
        <img
          src="@/assets/developerConference/cloud-light.png"
          alt="光子中心图标，点击进入光子乐园！"
          title="光子中心"
          class="img-animation"
          @click="
            jumpDetail('cloudLight');
            dataCollector('光子中心');
          "
        />
      </div>
      <div class="cloud-fourm-sub-bg">
        <img
          src="@/assets/developerConference/cloud-sub.png"
          alt="技术分论坛图标，点击进入分论坛页"
          title="技术分论坛"
          class="img-animation"
          @click="
            jumpDetail('subForum');
            dataCollector('技术分论坛');
          "
        />
      </div>
      <div class="cloud-market-bg">
        <img
          src="@/assets/developerConference/cloud-market.png"
          alt="U选商城图标，点击进入商城页"
          title="U选商城"
          class="img-animation"
          @click="
            jumpDetail('cloudMarket');
            dataCollector('U选商城');
          "
        />
      </div>
    </div>
    <!-- <starPopup /> -->
  </div>
</template>

<script>
import starPopup from "./components/tipPopup";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "CloudMeeting",
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["hsid"])
  },
  components: {
    starPopup
  },

  methods: {
    ...mapActions(["enrolltips"]),
    jumpDetail(path) {
      switch (path) {
        // case "cloudShow":
        //   this.enrolltips(true);
        //   // 为了更好地清理定时器
        //   const timer = setTimeout(() => this.enrolltips(false), 3000);
        //   this.$once("hook:beforeDestroy", () => {
        //     clearTimeout(timer);
        //   });
        //   break;
        case "cloudLight":
          window.open(window.LOCAL_CONFIG.PHOTON_URL, "_blank");
          break;
        case "cloudMarket":
          window.open(
            window.LOCAL_CONFIG.PHOTON_URL + "?anchorType=goods",
            "_blank"
          );
          break;
        default:
          this.$router.push({ path }).catch(() => {});
      }
    },
    // 对跳转的链接跳转动作进行埋点
    dataCollector(hallName_var) {
      this.gioTrackEvent("LDC_exhibitionAreaClick", {
        hallName_var,
        // deviceType_var: "Web",
        // hsUserId_var: this.hsid || "-"
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.bg-bg {
  min-width: 1200px;
  overflow: hidden;
  position: relative;
  min-height: 700px;
  height: 100vh;
}

.cloud-main-bg {
  width: 100%;
  height: 100%;
  background-image: url("../../../assets/developerConference/cloudshow-bg.jpg");
  background-repeat: no-repeat;
  background-size: cover;

  .cloud-show-bg {
    img {
      width: 140px;
      position: absolute;
      left: 330px;
      top: 100px;
      animation-name: csb;
    }
  }
  .cloud-fourm-main-bg {
    img {
      position: absolute;
      width: 160px;
      right: 19%;
      top: 33%;
      animation-name: cfmb;
    }
  }
  .cloud-light-bg {
    img {
      position: absolute;
      width: 180px;
      top: 24%;
      left: 51%;
      animation-name: clb;
    }
  }
  .cloud-fourm-sub-bg {
    img {
      position: absolute;
      width: 210px;
      top: 60%;
      left: 35%;
      animation-name: cfsb;
    }
  }
  .cloud-market-bg {
    img {
      position: absolute;
      width: 215px;
      bottom: 12%;
      right: 12%;
      animation-name: cmb;
    }
  }
  // 所有图片统一控制
  .img-animation {
    animation-duration: 1.2s;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    animation-timing-function: linear;
    cursor: pointer;
  }
  @keyframes csb {
    from {
      top: 100px;
    }
    25% {
      top: 96px;
    }
    50% {
      top: 92px;
    }
    75% {
      top: 88px;
    }
    to {
      top: 84px;
    }
  }
  @keyframes cfmb {
    from {
      top: 33%;
    }
    to {
      top: 32%;
    }
  }
  @keyframes cfsb {
    from {
      top: 60%;
    }
    to {
      top: 59%;
    }
  }
  @keyframes clb {
    from {
      top: 23%;
    }
    to {
      top: 24%;
    }
  }
  @keyframes cmb {
    from {
      bottom: 9%;
    }
    to {
      bottom: 8%;
    }
  }
}
@media (max-width: 1366px), (max-height: 700px) {
  .cloud-main-bg {
    .cloud-show-bg {
      img {
        width: 109px;
        position: absolute;
        left: 18%;
        top: 5%;
        animation-name: csb;
      }
    }
    .cloud-fourm-main-bg {
      img {
        position: absolute;
        width: 110px;
        right: 19%;
        top: 32%;
        animation-name: cfmb;
      }
    }
    .cloud-light-bg {
      img {
        position: absolute;
        width: 130px;
        top: 22%;
        left: 51%;
        animation-name: clb;
      }
    }
    .cloud-fourm-sub-bg {
      img {
        position: absolute;
        width: 150px;
        top: 55%;
        left: 35%;
        animation-name: cfsb;
      }
    }
    .cloud-market-bg {
      img {
        position: absolute;
        width: 150px;
        top: 65%;
        right: 12%;
        animation-name: cmb;
      }
    }
    @keyframes csb {
      from {
        top: 5%;
      }
      to {
        top: 6%;
      }
    }
    @keyframes cfmb {
      from {
        top: 33%;
      }
      to {
        top: 31%;
      }
    }
    @keyframes cfsb {
      from {
        top: 56%;
      }
      to {
        top: 54%;
      }
    }
    @keyframes clb {
      from {
        top: 21%;
      }
      to {
        top: 23%;
      }
    }
    @keyframes cmb {
      from {
        top: 66%;
      }
      to {
        top: 64%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/developerConference/cloudMeeting.vue